import React, { useEffect, useState } from "react";
import AddEditForm from "../../AddEditForm";
import { axios } from "../../../../Global";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PromptElement from "../../PromptElement";
import ListDataCompany from "./ListDataCompany";
import AddEditFormCompany from "./AddEditFormCompany";
import { printValidationError } from "../../../../utils/functions";
import { checkAccessFn } from "../../../../utils/checkAccess";
import Breadcrumb from "../../../../utils/BreadCrumb";
import {
  setAppError,
  setPage,
  setBreadCrumb,
} from "../../../../store/userSlice";

export default function VisaProviders(props) {
  const [showPromptElement, setShowPromptElement] = useState({
    open: false,
    id: null,
  });
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [submitFormLoading, setSubmitFormLoading] = useState(false);
  const [loading, setLoading] = useState({
    edit: false,
    delete: false,
    listData: false,
    loadingId: "",
  });
  const [listLoading,setListLoading] = useState(false)
  const [clientList, setClientList] = useState([]);
  const [addOrEdit, setAddOrEdit] = useState({
    open: false,
    method: "",
    loadedValues: {},
    editId: "",
  });

  useEffect(() => {
    if (location.pathname.split("/")[3] === "create") {
      setAddOrEdit((p) => ({ ...p, open: true, method: "add" }));
    } else {
      setAddOrEdit((p) => ({ ...p, open: false }));
    }
  }, [location]);

  const [visaSegment, setVisaSegment] = useState("");
  const [subSegment, setSubSegment] = useState("");
  const [name, setName] = useState("");
  const [nameArabic, setNameArabic] = useState("");
  const [sponsorName, setSponsorName] = useState("");
  const [address, setAddress] = useState("");
  const [addressArabic, setAdressArabic] = useState("");
  const [pobox, setPoBox] = useState("");
  const [pincode, setPincode] = useState("");
  const [nationalIdentityNumber, setNationalIdentityNumber] = useState("");
  const [SigningAuthorityPersonName, setSigningAuthorityPersonName] =
    useState("");
  const [SigningAuthorityDesignation, setSigningAuthorityDesignation] =
    useState("");
  const [SigningAuthorityContact, setSigningAuthorityContact] = useState("");
  const [SigningAuthorityEmail, setSigningAuthorityEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [headOfficeLocation, setHeadOfficeLocation] = useState("");
  const [companyRegistration, setCompanyRegistration] = useState("");
  const [laborLicenseNumber, setLaborLicenseNumber] = useState("");
  const [sponsorId, setSponsorId] = useState("");
  const [vatNumber, setVatNumber] = useState("");
  const [authorizedPersonName, setAuthorizedPersonName] = useState("");
  const [authorizedPersonDesignation, setAuthorizedPersonDesignation] =
    useState("");
  const [authorizedPersonContact, setAuthorizedPersonContact] = useState("");
  const [authorizedPersonEmail, setAuthorizedPersonEmail] = useState("");
  const [
    authorizedProjectRepresentativeName,
    setAuthorizedProjectRepresentativeName,
  ] = useState("");
  const [
    authorizedProjectRepresentativeDesignation,
    setAuthorizedProjectRepresentativeDesignation,
  ] = useState("");
  const [
    authorizedProjectRepresentativeContact,
    setAuthorizedProjectRepresentativeContact,
  ] = useState("");
  const [
    authorizedProjectRepresentativeEmail,
    setAuthorizedProjectRepresentativeEmail,
  ] = useState("");
  const [
    authorizedAccountsRepresentativeName,
    setAuthorizedAccountsRepresentativeName,
  ] = useState("");
  const [
    authorizedAccountsRepresentativeDesignation,
    setAuthorizedAccountsRepresentativeDesignation,
  ] = useState("");
  const [
    authorizedAccountsRepresentativeContact,
    setAuthorizedAccountsRepresentativeContact,
  ] = useState("");
  const [
    authorizedAccountsRepresentativeEmail,
    setAuthorizedAccountsRepresentativeEmail,
  ] = useState("");
  const [beneficiaryBank, setBeneficiaryBank] = useState("");
  const [bankName, setBankName] = useState("");
  const [bankBranch, setBankBranch] = useState("");
  const [bankType, setBankType] = useState("");
  const [bankAccountNumber, setBankAccountNumber] = useState("");
  const [bankIban, setBankIban] = useState("");
  const [companyLogo, setLogo] = useState("");
  const [headerImage, setHeaderImage] = useState("");
  const [footerImage, setFooterImage] = useState("");

  const [headerPreview, setHeaderPreview] = useState("");
  const [footerPreview, setFooterPreview] = useState("");

  const token = localStorage.getItem("token");
  useEffect(() => {
    setListLoading(true)
    axios
      .get("/dashboard/company", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setClientList(res?.data?.data?.company || []);
        setListLoading(false);
      })
      .catch((err) => {
        setListLoading(false);
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      });
  }, [loading.delete, addOrEdit.open]);

  const submitForm = async (event, logo, headerImage, footerImage) => {
    event.preventDefault();
    setSubmitFormLoading(true);
    try {
      let response;
      const formData = new FormData();
      formData.append("visa_segment", visaSegment?.toUpperCase());
      formData.append("sub_segment", subSegment?.toUpperCase());
      formData.append("name", name?.toUpperCase());
      formData.append("sponsor_name", sponsorName?.toUpperCase());
      formData.append("address", address?.toUpperCase());
      formData.append("mobile", mobile?.toUpperCase());
      formData.append("email", email?.toUpperCase());
      formData.append("name_arabic", nameArabic?.toUpperCase());
      formData.append("address_arabic", addressArabic?.toUpperCase());
      formData.append("po_box", pobox?.toUpperCase());
      formData.append("pincode", pincode?.toUpperCase());
      formData.append(
        "national_identification_number",
        nationalIdentityNumber?.toUpperCase()
      );
      formData.append(
        "signing_authority_person_contact",
        SigningAuthorityContact
      );
      formData.append(
        "signing_authority_person_name",
        SigningAuthorityPersonName?.toUpperCase()
      );
      formData.append(
        "signing_authority_person_email",
        SigningAuthorityEmail?.toUpperCase()
      );
      formData.append(
        "signing_authority_person_designation",
        SigningAuthorityDesignation?.toUpperCase()
      );

      if (logo && logo.name) {
        formData.append("logo", logo);
      }
      formData.append(
        "head_office_location",
        headOfficeLocation?.toUpperCase()
      );
      formData.append(
        "company_registration",
        companyRegistration?.toUpperCase()
      );
      formData.append(
        "labor_license_number",
        laborLicenseNumber?.toUpperCase()
      );
      formData.append("sponsor_id", sponsorId?.toUpperCase());
      formData.append("vat_number", vatNumber?.toUpperCase());
      formData.append(
        "authorized_person_name",
        authorizedPersonName?.toUpperCase()
      );
      formData.append(
        "authorized_person_designation",
        authorizedPersonDesignation?.toUpperCase()
      );
      formData.append("authorized_person_contact", authorizedPersonContact);
      formData.append(
        "authorized_person_email",
        authorizedPersonEmail?.toUpperCase()
      );
      formData.append(
        "authorized_project_representative_name",
        authorizedProjectRepresentativeName?.toUpperCase()
      );
      formData.append(
        "authorized_project_representative_designation",
        authorizedProjectRepresentativeDesignation?.toUpperCase()
      );
      formData.append(
        "authorized_project_representative_contact",
        authorizedProjectRepresentativeContact
      );
      formData.append(
        "authorized_project_representative_email",
        authorizedProjectRepresentativeEmail?.toUpperCase()
      );
      formData.append(
        "authorized_accounts_representative_name",
        authorizedAccountsRepresentativeName?.toUpperCase()
      );
      formData.append(
        "authorized_accounts_representative_designation",
        authorizedAccountsRepresentativeDesignation?.toUpperCase()
      );
      formData.append(
        "authorized_accounts_representative_contact",
        authorizedAccountsRepresentativeContact
      );
      formData.append(
        "authorized_accounts_representative_email",
        authorizedAccountsRepresentativeEmail?.toUpperCase()
      );
      formData.append("beneficiary_bank", beneficiaryBank?.toUpperCase());
      formData.append("bank_name", bankName?.toUpperCase());
      formData.append("bank_branch", bankBranch?.toUpperCase());
      formData.append("bank_type", bankType?.toUpperCase());
      formData.append("bank_account_number", bankAccountNumber);
      formData.append("bank_iban", bankIban?.toUpperCase());
      if (headerImage && headerImage?.name) {
        formData.append("header", headerImage);
      }
      if (footerImage && footerImage?.name) {
        formData.append("footer", footerImage);
      }
      if (addOrEdit.method === "add") {
        response = await axios.post(`/dashboard/company`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        });
      } else if (addOrEdit.method === "edit") {
        response = await axios.post(
          `/dashboard/company/${addOrEdit.editId}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
      }
      const data = response.data.data;
      if (data) {
        navigate("/dashboard/visa-providers");
        dispatch(
          setAppError({
            msg: response.data.message,
            color: "bg-green-700",
          })
        );
        setSubmitFormLoading(false);
        setAddOrEdit((p) => ({ ...p, open: false }));
      }
    } catch (err) {
      setSubmitFormLoading(false);
      printValidationError(err, "company");
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };
  const cancelForm = () => {
    navigate("/dashboard/visa-providers");
    setAddOrEdit((p) => ({ ...p, open: false }));
  };
  const editData = async (id) => {
    setHeaderImage();
    setFooterImage();
    setHeaderPreview();
    setFooterPreview();
    navigate(`/dashboard/visa-providers/edit-visa-providers/${id}`);
    if (id) {
      setLoading((p) => ({ ...p, edit: true, loadingId: id }));
      try {
        const response = await axios.get(`/dashboard/company/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = response?.data?.data?.company;
        setLoading((p) => ({ ...p, edit: false, loadingId: "" }));
        setAddOrEdit((p) => ({
          ...p,
          open: true,
          method: "edit",
          // loadedValues: data,
          editId: id,
        }));
        setVisaSegment(data.visa_segment);
        setSubSegment(data.sub_segment);
        setName(data.name);
        setNameArabic(data.name_arabic);
        setSponsorName(data.sponsor_name);
        setMobile(data.mobile);
        setEmail(data.email);
        setAddress(data.address);
        setAdressArabic(data.address_arabic);
        setPoBox(data.po_box);
        setPincode(data.pincode);
        setNationalIdentityNumber(data.national_identification_number);
        setHeadOfficeLocation(data.head_office_location);
        setCompanyRegistration(data.company_registration);
        setLaborLicenseNumber(data.labor_license_number);
        setSponsorId(data.sponsor_id);
        setVatNumber(data.vat_number);
        setAuthorizedPersonName(data.authorized_person_name);
        setAuthorizedPersonDesignation(data.authorized_person_designation);
        setAuthorizedPersonContact(data.authorized_person_contact);
        setAuthorizedPersonEmail(data.authorized_person_email);
        setSigningAuthorityContact(data.signing_authority_person_contact);
        setSigningAuthorityPersonName(data.signing_authority_person_name);
        setSigningAuthorityEmail(data.signing_authority_person_email);
        setSigningAuthorityDesignation(
          data.signing_authority_person_designation
        );
        setAuthorizedProjectRepresentativeName(
          data.authorized_project_representative_name
        );
        setAuthorizedProjectRepresentativeDesignation(
          data.authorized_project_representative_designation
        );
        setAuthorizedProjectRepresentativeContact(
          data.authorized_project_representative_contact
        );
        setAuthorizedProjectRepresentativeEmail(
          data.authorized_project_representative_email
        );
        setAuthorizedAccountsRepresentativeName(
          data.authorized_accounts_representative_name
        );
        setAuthorizedAccountsRepresentativeDesignation(
          data.authorized_accounts_representative_designation
        );
        setAuthorizedAccountsRepresentativeContact(
          data.authorized_accounts_representative_contact
        );
        setAuthorizedAccountsRepresentativeEmail(
          data.authorized_accounts_representative_email
        );
        setBeneficiaryBank(data.beneficiary_bank);
        setBankName(data.bank_name);
        setBankBranch(data.bank_branch);
        setBankType(data.bank_type);
        setBankAccountNumber(data.bank_account_number);
        setBankIban(data.bank_iban);
        setLogo(data?.logo);
        setHeaderImage(data?.header);
        setFooterImage(data?.footer);
        setHeaderPreview(data?.header);
        setFooterPreview(data?.footer);
      } catch (err) {
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      }
    }
  };
  const deleteData = async (id) => {
    if (id) {
      setLoading((p) => ({ ...p, delete: true, loadingId: id }));
      try {
        const response = await axios.delete(`/dashboard/company/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.status === 200) {
          setLoading((p) => ({ ...p, delete: false, loadingId: "" }));
          dispatch(
            setAppError({
              msg: response.data.message,
              color: "bg-green-700",
            })
          );
        }
      } catch (err) {
        setLoading((p) => ({ ...p, delete: false }));
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
        if (err?.response?.status === 403) {
          if (err?.response?.data?.message) {
            dispatch(
              setAppError({
                msg: err?.response?.data.message,
              })
            );
          }
        }
      }
    }
  };

  const addData = () => {
    setAddOrEdit((p) => ({ ...p, open: true, method: "add" }));
    setVisaSegment("");
    setSubSegment("");
    setName("");
    setAdressArabic("");
    setNameArabic("");
    setPoBox("");
    setPincode("");
    setNationalIdentityNumber("");
    setSigningAuthorityContact("");
    setSigningAuthorityDesignation("");
    setSigningAuthorityEmail("");
    setSigningAuthorityPersonName("");
    setAddress("");
    setEmail("");
    setMobile("");
    setSponsorName("");
    setHeadOfficeLocation("");
    setCompanyRegistration("");
    setLaborLicenseNumber("");
    setSponsorId("");
    setVatNumber("");
    setAuthorizedPersonName("");
    setAuthorizedPersonDesignation("");
    setAuthorizedPersonContact("");
    setAuthorizedPersonEmail("");
    setAuthorizedProjectRepresentativeName("");
    setAuthorizedProjectRepresentativeDesignation("");
    setAuthorizedProjectRepresentativeContact("");
    setAuthorizedProjectRepresentativeEmail("");
    setAuthorizedAccountsRepresentativeName("");
    setAuthorizedAccountsRepresentativeDesignation("");
    setAuthorizedAccountsRepresentativeContact("");
    setAuthorizedAccountsRepresentativeEmail("");
    setBeneficiaryBank("");
    setBankName("");
    setBankBranch("");
    setBankType("");
    setBankAccountNumber("");
    setBankIban("");
    setLogo("");
    setHeaderImage();
    setFooterImage();
    setHeaderPreview();
    setFooterPreview();
  };

  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) =>
    checkAccessFn(dashboardData, module, name);

  const isCreateMode = location.pathname.endsWith("/visa-providers/create");
  const isEditMode = location.pathname.includes(
    "/visa-providers/edit-visa-providers"
  );

  useEffect(() => {
    if ((isCreateMode || isEditMode) && !addOrEdit.method)
      navigate("/dashboard/visa-providers");
  }, []);

  const commonItems = [
    { label: "VISA PROVIDER", link: "/dashboard/visa-providers/" },
  ];
  const breadcrumbItems = isEditMode
    ? [...commonItems, { label: "EDIT", link: "" }]
    : isCreateMode
    ? [...commonItems, { label: "CREATE", link: "/dashboard/visaproviders" }]
    : commonItems;

  useEffect(() => {
    dispatch(setBreadCrumb(breadcrumbItems));
  }, [location.pathname]);

  return (
    <>
      {showPromptElement.open && (
        <PromptElement
          showPromptElement={showPromptElement}
          setShowPromptElement={setShowPromptElement}
          deleteHandler={deleteData}
        />
      )}
      <div className={`p-2  sm:p-5 `}>
        {!addOrEdit.open && (
          <>
            <ListDataCompany
              list={clientList}
              editData={editData}
              deleteData={setShowPromptElement}
              loading={loading}
              listLoading={listLoading}
              column={4}
              titles={[
                "S.No.",
                "Visa provider name",
                "Logo",
                "Visa provider id",
                "Company sponsor id (700 series)",
                "Autherized person name",
                "CR Number",
                "Action",
              ]}
              addData={addData}
            />
          </>
        )}
        {addOrEdit.open && (
          <AddEditFormCompany
            form={[
              {
                type: "select",
                text: "VISA Segment",
                name: "visa_segment",
                value: visaSegment,
                update: setVisaSegment,
                columnName: "visa_segment",
                options: ["OWN", "THIRD PARTY"],
              },
              {
                type: "select",
                text: "Sub Segment",
                name: "sub_segment",
                value: subSegment,
                update: setSubSegment,
                columnName: "sub_segment",
                options: ["MR. OKAB", "MR. ALI"],
              },
              {
                type: "text",
                text: "Visa Provider Name English",
                name: "name",
                value: name,
                update: setName,
                columnName: "name",
              },
              {
                type: "text",
                text: "Visa Provider Name Arabic",
                name: "nameArabic",
                value: nameArabic,
                update: setNameArabic,
                columnName: "name_arabic",
              },

              {
                type: "email",
                text: "Visa Provider Email",
                name: "email",
                value: email,
                update: setEmail,
                columnName: "email",
              },
              {
                type: "number",
                text: "Visa Provider Landline Number",
                name: "mobile",
                value: mobile,
                update: setMobile,
                columnName: "mobile",
              },
              {
                type: "textarea",
                text: "Visa Provider National Address English",
                name: "address",
                value: address,
                update: setAddress,
                columnName: "address",
              },
              {
                type: "textarea",
                text: "Visa Provider National Address Arabic",
                name: "addressArabic",
                value: addressArabic,
                update: setAdressArabic,
                columnName: "address_arabic",
              },
              {
                type: "text",
                text: "Visa Provider PO Box",
                name: "poBox",
                value: pobox,
                update: setPoBox,
                columnName: "po_box",
              },
              {
                type: "number",
                text: "Visa Provider Pin Code",
                name: "pincode",
                value: pincode,
                update: setPincode,
                columnName: "pincode",
              },
              {
                type: "number",
                text: "Visa Provider BATAKA ID NO",
                name: "nationalIdentityNo",
                value: nationalIdentityNumber,
                update: setNationalIdentityNumber,
                columnName: "national_identity_no",
              },
              {
                type: "textarea",
                text: "Visa Provider Head Office Location",
                name: "headOfficeLocation",
                value: headOfficeLocation,
                update: setHeadOfficeLocation,
                columnName: "head_office_location",
              },
              {
                type: "text",
                text: "Visa Provider CR Number",
                name: "companyRegistration",
                value: companyRegistration,
                update: setCompanyRegistration,
                columnName: "company_registration",
              },
              {
                type: "text",
                text: "Visa Provider Labor Office File number (MOL)",
                name: "laborLicenseNumber",
                value: laborLicenseNumber,
                update: setLaborLicenseNumber,
                columnName: "labor_license_number",
              },
              {
                type: "text",
                text: "Visa Provider Sponsor ID (700 series)",
                name: "sponsorId",
                value: sponsorId,
                update: setSponsorId,
                columnName: "sponsor_id",
              },
              {
                type: "text",
                text: "Visa Provider Vat Number",
                name: "vatNumber",
                value: vatNumber,
                update: setVatNumber,
                columnName: "vat_number",
              },
              {
                type: "text",
                text: "Visa Provider Authorized Person Name",
                name: "authorizedPersonName",
                value: authorizedPersonName,
                update: setAuthorizedPersonName,
                columnName: "authorized_person_name",
              },
              {
                type: "text",
                text: "Visa Provider Authorized Person Designation",
                name: "authorizedPersonDesignation",
                value: authorizedPersonDesignation,
                update: setAuthorizedPersonDesignation,
                columnName: "authorized_person_designation",
              },
              {
                type: "text",
                text: "Visa Provider Authorized Person Contact",
                name: "authorizedPersonContact",
                value: authorizedPersonContact,
                update: setAuthorizedPersonContact,
                columnName: "authorized_person_contact",
              },
              {
                type: "email",
                text: "Visa Provider Authorized Person Email",
                name: "authorizedPersonEmail",
                value: authorizedPersonEmail,
                update: setAuthorizedPersonEmail,
                columnName: "authorized_person_email",
              },
              {
                type: "text",
                text: "Visa Provider Signing Authority Person Name",
                name: "SigningAuthorityPersonName",
                value: SigningAuthorityPersonName,
                update: setSigningAuthorityPersonName,
                columnName: "signing_suthority_person_name",
              },
              {
                type: "text",
                text: "Visa Provider Signing Authority Designation",
                name: "SigningAuthorityDesignation",
                value: SigningAuthorityDesignation,
                update: setSigningAuthorityDesignation,
                columnName: "signing_authority_designation",
              },
              {
                type: "number",
                text: "Visa Provider Signing Authority Contact",
                name: "SigningAuthorityContact",
                value: SigningAuthorityContact,
                update: setSigningAuthorityContact,
                columnName: "signing_authority_contact",
              },
              {
                type: "email",
                text: "Visa Provider Signing Authority Email",
                name: "SigningAuthorityEmail",
                value: SigningAuthorityEmail,
                update: setSigningAuthorityEmail,
                columnName: "signing_authority_Email",
              },
              {
                type: "text",
                text: "Visa Provider Authorized Project Representative Name",
                name: "authorizedProjectRepresentativeName",
                value: authorizedProjectRepresentativeName,
                update: setAuthorizedProjectRepresentativeName,
                columnName: "authorized_project_representative_name",
              },
              {
                type: "text",
                text: "Visa Provider Authorized Project Representative Designation",
                name: "authorizedProjectRepresentativeDesignation",
                value: authorizedProjectRepresentativeDesignation,
                update: setAuthorizedProjectRepresentativeDesignation,
                columnName: "authorized_project_representative_designation",
              },
              {
                type: "text",
                text: "Visa Provider Authorized Project Representative Contact",
                name: "authorizedProjectRepresentativeContact",
                value: authorizedProjectRepresentativeContact,
                update: setAuthorizedProjectRepresentativeContact,
                columnName: "authorized_project_representative_contact",
              },
              {
                type: "email",
                text: "Visa Provider Authorized Project Representative Email",
                name: "authorizedProjectRepresentativeEmail",
                value: authorizedProjectRepresentativeEmail,
                update: setAuthorizedProjectRepresentativeEmail,
                columnName: "authorized_project_representative_email",
              },
              {
                type: "text",
                text: "Visa Provider Authorized Accounts Representative Name",
                name: "authorizedAccountsRepresentativeName",
                value: authorizedAccountsRepresentativeName,
                update: setAuthorizedAccountsRepresentativeName,
                columnName: "authorized_accounts_representative_name",
              },
              {
                type: "text",
                text: "Visa Provider Authorized Accounts Representative Designation",
                name: "authorizedAccountsRepresentativeDesignation",
                value: authorizedAccountsRepresentativeDesignation,
                update: setAuthorizedAccountsRepresentativeDesignation,
                columnName: "authorized_accounts_representative_designation",
              },
              {
                type: "text",
                text: "Visa Provider Authorized Accounts Representative Contact",
                name: "authorizedAccountsRepresentativeContact",
                value: authorizedAccountsRepresentativeContact,
                update: setAuthorizedAccountsRepresentativeContact,
                columnName: "authorized_accounts_representative_contact",
              },
              {
                type: "email",
                text: "Visa Provider Authorized Accounts Representative Email",
                name: "authorizedAccountsRepresentativeEmail",
                value: authorizedAccountsRepresentativeEmail,
                update: setAuthorizedAccountsRepresentativeEmail,
                columnName: "authorized_accounts_representative_email",
              },
              {
                type: "text",
                text: "Visa Provider ACCOUNT NAME",
                name: "beneficiaryBank",
                value: beneficiaryBank,
                update: setBeneficiaryBank,
                columnName: "beneficiary_bank",
              },
              {
                type: "text",
                text: "Visa Provider Bank Name",
                name: "bankName",
                value: bankName,
                update: setBankName,
                columnName: "bank_name",
              },
              {
                type: "text",
                text: "Visa Provider Bank Branch",
                name: "bankBranch",
                value: bankBranch,
                update: setBankBranch,
                columnName: "bank_branch",
              },
              {
                type: "text",
                text: "Visa Provider Bank Type",
                name: "bankType",
                value: bankType,
                update: setBankType,
                columnName: "bank_type",
              },
              {
                type: "number",
                text: "Visa Provider Bank Account Number",
                name: "bankAccountNumber",
                value: bankAccountNumber,
                update: setBankAccountNumber,
                columnName: "bank_account_number",
              },
              {
                type: "text",
                text: "Visa Provider Bank Iban",
                name: "bankIban",
                value: bankIban,
                update: setBankIban,
                columnName: "bank_iban",
              },
              // {
              //   type: "file",
              //   name: "logo",
              //   value: companyLogo,
              //   update: setLogo,
              //   columnName: "logo",
              // },
            ]}
            submitForm={submitForm}
            cancelForm={cancelForm}
            submitFormLoading={submitFormLoading}
            loadedValues={
              addOrEdit.method === "edit" && addOrEdit.loadedValues
                ? true
                : false
            }
            logo={companyLogo}
            setLogo={setLogo}
            headerImage={headerImage}
            setHeaderImage={setHeaderImage}
            footerImage={footerImage}
            setFooterImage={setFooterImage}
            headerPreview={headerPreview}
            footerPreview={footerPreview}
            setHeaderPreview={setHeaderPreview}
            setFooterPreview={setFooterPreview}
            component="Visa Provider"
          />
        )}
      </div>
    </>
  );
}
